import FormattedMessage from 'I18n/components/FormattedMessage';
import { DeleteIcon, DownCaratIcon, DuplicateIcon, TableIcon } from 'foundations-assets';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/transitional/components/View';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DropdownButton = props => /*#__PURE__*/_jsx(IconButton, Object.assign({}, props, {
  children: /*#__PURE__*/_jsx(DownCaratIcon, {})
}));
function TableFloatyPopoverBody({
  onCloneTable,
  onDeleteTable,
  onOpenStart,
  onSelectTable
}) {
  return /*#__PURE__*/_jsxs(ButtonGroup, {
    orientation: "horizontal",
    children: [/*#__PURE__*/_jsx(Tooltip, {
      placement: "top",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "RichTextLib.table.floaty.tableSelectorTooltip"
      }),
      children: /*#__PURE__*/_jsxs(Button, {
        "data-test-id": "select-table-btn",
        size: "xs",
        use: "tertiary",
        onClick: onSelectTable,
        children: [/*#__PURE__*/_jsx(TableIcon, {
          alignWithText: true
        }), /*#__PURE__*/_jsx(View, {
          blockSize: "16px",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "RichTextLib.table.floaty.tableSelectorLabel"
          })
        })]
      })
    }), /*#__PURE__*/_jsx(Dropdown, {
      Button: DropdownButton,
      buttonSize: "xs",
      buttonUse: "tertiary",
      onOpenComplete: onOpenStart,
      children: /*#__PURE__*/_jsxs(List, {
        children: [/*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsxs(Button, {
            "data-test-id": "copy-table-btn",
            onClick: onCloneTable,
            children: [/*#__PURE__*/_jsx(DuplicateIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "RichTextLib.table.floaty.cloneTable"
            })]
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsxs(Button, {
            "data-test-id": "delete-table-btn",
            onClick: onDeleteTable,
            children: [/*#__PURE__*/_jsx(DeleteIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "RichTextLib.table.floaty.deleteTable"
            })]
          })
        })]
      })
    })]
  });
}
export default TableFloatyPopoverBody;